import { Link } from "react-router-dom";
import { Button } from "../../../components/ui/button";
import ProposalDraftCard from "../../../components/proposal-draft-card.components";
import Spinner from "../../../components/spinner.components";
import { useEffect, useState, type FunctionComponent } from "react";
import type { IProposal } from "../../../types/models/proposals.modals.types";
import { useGetAllProposalsAdminHttp } from "../../../hooks/http/admin/proposals/get-all-proposals.admin.http";
import { handleHttpError } from "../../../utils/utils";
import { useToast } from "../../../hooks/use-toast";
import { Plus } from "lucide-react";

export default function ProposalsAdminPartial() {
  const { execute: getAllProposals, fetching: fetchingProposals } =
    useGetAllProposalsAdminHttp();
  const [proposals, setProposals] = useState<IProposal[]>([]);

  const { toast } = useToast();

  async function fetchProposals() {
    const response = await getAllProposals({
      body: null,
    });
    if (!response.success) {
      return handleHttpError(response, toast);
    }
    setProposals(response.data.proposals);
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    fetchProposals();
  }, []);

  return (
    <div className="flex flex-col gap-8 px-8 pt-12 w-full">
      <div className="flex justify-between items-center gap-4 pb-5 w-full">
        <span className="font-semibold text-2xl">Campaign proposals</span>
        <Link to="/admin/proposals/proposal/campaign-details">
          <Button className="bg-primarybuttonbg px-10 py-6 border border-border font-semibold text-black">
            <Plus className="mr-2" />
            Create proposal
          </Button>
        </Link>
      </div>
      <div className="flex flex-col gap-8 pb-10">
        <ProposalCards fetching={fetchingProposals} proposals={proposals} />
      </div>
    </div>
  );
}

interface ProposalCardsProps {
  fetching: boolean;
  proposals: IProposal[];
}

const ProposalCards: FunctionComponent<ProposalCardsProps> = ({
  fetching,
  proposals: proposalsData,
}) => {
  if (proposalsData.length === 0 && fetching) {
    return (
      <div className="flex flex-col flex-1 justify-center items-center">
        <Spinner />
      </div>
    );
  }

  if (proposalsData.length === 0) {
    return (
      <div className="flex flex-col flex-1 justify-center items-center">
        <p className="text-center text-secondary text-sm">No campaigns found</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center">
        <div className="gap-6 grid grid-cols-3 w-full">
          {proposalsData.map((proposal) => {
            return <ProposalDraftCard key={proposal.id} proposal={proposal} />;
          })}
        </div>
      </div>
    </div>
  );
};
